import React from 'react';
import ReactDOM from 'react-dom/client';
import Routess from './pages/Routess';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Routess />
  </React.StrictMode>
);